import Grid from '@mui/material/Grid'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Button } from '../../features/section-components/Button'
import { SectionHeader } from '../../features/section-components/SectionHeader'
import styles from './EditName.module.scss'
import { LoadingIcon } from '../../features/section-components/LoadingIcon'
import { TextboxMobile } from '../../features/section-components/Textbox'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import JNJFooter from '../../features/jnj-footer/JNJFooter'

function EditNameMobile({
  t,
  userCallStatus,
  values,
  errors,
  handleChange,
  handleSubmit,
  onCancel,
  isSaving,
  isDisabled,
}) {
  const loading = userCallStatus === 'loading'

  return (
    <MarginWrapper>
      <LoadingIcon isLoading={loading}>
        <div className={styles['edit-name-mobile']} />
        <div className={styles['edit-name-container-mobile']}>
          <div className={styles['back-home-section']}>
            <Link
              to="/account"
              style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
              color="black"
            >
              <ArrowBackIosIcon
                className={styles['home-icon']}
                fontSize="inherit"
              />
              <div className={styles['home-text']}>{t('account-tab')}</div>
            </Link>
          </div>
          <SectionHeader text={t('label-name')} size="medium" />
          <span className={styles['form-secondary-text']}>
            {t('support-text-name')}
          </span>

          <div className={styles['form-field']}>
            <span className={styles['form-label']}>
              {t('label-first-name')}
            </span>
            <TextboxMobile
              name="firstName"
              value={values.firstName}
              onChange={(e) => {
                handleChange({
                  target: {
                    name: 'firstName',
                    value: e.target.value
                  }
                })
              }}
              error={!!errors.firstName}
              supportText={errors.firstName ? t('error-invalid-character') : ''}
              required
            />
          </div>

          <div className={styles['form-field']}>
            <span className={styles['form-label']}>
              {t('label-last-name-optional')}
            </span>
            <TextboxMobile
              name="lastName"
              value={values.lastName}
              onChange={(e) => {
                handleChange({
                  target: {
                    name: 'lastName',
                    value: e.target.value
                  }
                })
              }}
              error={!!errors.lastName}
              supportText={errors.lastName ? t('error-invalid-character') : ''}
            />
          </div>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={10}
            xl={10}
            className={styles['edit-name-buttons']}
          >
            <Button
              text={isSaving ? '' : t('button-save-changes')}
              onClick={handleSubmit}
              buttonStyle="cta-red-oval"
              disabled={isDisabled || isSaving || values.firstName.trim().length === 0}
              icon={isSaving ? <LoadingIcon isLoading size="small" /> : null}
            />
            <Link to="/account" styles={{ textDecoration: 'none' }}>
              <Button
                text={t('button-cancel')}
                buttonStyle="filled-grey-oval"
                onClick={onCancel}
              />
            </Link>
          </Grid>
        </div>

        <div className={styles['JNJ-footer']}>
          <JNJFooter />
        </div>
      </LoadingIcon>
    </MarginWrapper>
  )
}

EditNameMobile.propTypes = {
  t: PropTypes.func.isRequired,
  userCallStatus: PropTypes.string.isRequired,
  values: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  errors: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default EditNameMobile
